/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Index_Link_Resource_TagsInputs */

const en_admin_resources_index_link_resource_tags = /** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource Tags`)
};

const de_admin_resources_index_link_resource_tags = /** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen-Tags`)
};

const es_admin_resources_index_link_resource_tags = /** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas de recursos`)
};

const fr_admin_resources_index_link_resource_tags = /** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags de ressources`)
};

const nl_admin_resources_index_link_resource_tags = /** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorzieningstags`)
};

/** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */
const it_admin_resources_index_link_resource_tags = en_admin_resources_index_link_resource_tags;

/** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */
const pt_br2_admin_resources_index_link_resource_tags = en_admin_resources_index_link_resource_tags;

/** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */
const pl_admin_resources_index_link_resource_tags = en_admin_resources_index_link_resource_tags;

/** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */
const hu_admin_resources_index_link_resource_tags = en_admin_resources_index_link_resource_tags;

/** @type {(inputs: Admin_Resources_Index_Link_Resource_TagsInputs) => LocalizedString} */
const ro_admin_resources_index_link_resource_tags = en_admin_resources_index_link_resource_tags;

/**
* | output |
* | --- |
* | "Resource Tags" |
*
* @param {Admin_Resources_Index_Link_Resource_TagsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_index_link_resource_tags = /** @type {((inputs?: Admin_Resources_Index_Link_Resource_TagsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Index_Link_Resource_TagsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_index_link_resource_tags(inputs)
	if (locale === "de") return de_admin_resources_index_link_resource_tags(inputs)
	if (locale === "es") return es_admin_resources_index_link_resource_tags(inputs)
	if (locale === "fr") return fr_admin_resources_index_link_resource_tags(inputs)
	if (locale === "nl") return nl_admin_resources_index_link_resource_tags(inputs)
	if (locale === "it") return it_admin_resources_index_link_resource_tags(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_index_link_resource_tags(inputs)
	if (locale === "pl") return pl_admin_resources_index_link_resource_tags(inputs)
	if (locale === "hu") return hu_admin_resources_index_link_resource_tags(inputs)
	return ro_admin_resources_index_link_resource_tags(inputs)
});
export { admin_resources_index_link_resource_tags as "admin.resources.index_link_resource_tags" }